import React from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Link } from '@material-ui/core';
import { removeLocalePath } from 'utils/router';
import { clearBookingSession } from 'utils/bookingSession';
import { setLocaleCookie } from 'utils/cookies/setCookie';
import localeTypes from 'utils/constants/locale/localeTypes';
import FaGlobeIcon from '../../Icons/FaGlobe';

const { ENGLISH, JAPANESE } = localeTypes;

const useStyles = makeStyles(theme => ({
  icon: {
    color: theme.palette.appBar.main,
    margin: '0 5px',
  },
  link: {
    fontFamily: theme.custom.romanFontFamily,
    fontSize: theme.typography.fontSize,
  },
}));

const LocaleSelect = () => {
  const classes = useStyles();
  const { locale } = useIntl();
  const location = useLocation();
  const pathName = location?.pathname;
  const query = location?.search ?? '';
  const adjustedPath = removeLocalePath(pathName);

  const isJapanese = locale === JAPANESE.key;
  const localeToSwitch = isJapanese ? ENGLISH : JAPANESE;
  const url = `/${localeToSwitch.key}${adjustedPath}${query}`;

  const onLocaleClick = () => {
    setLocaleCookie(localeToSwitch.key);
    clearBookingSession();
  };

  return (
    <Grid container item direction="row" alignItems="center" justifyContent="flex-end">
      <FaGlobeIcon className={classes.icon} fontSize="small" viewBox="0 0 612 652" />
      <Link onClick={onLocaleClick} className={classes.link} alt="language" href={url}>
        {localeToSwitch.text}
      </Link>
    </Grid>
  );
};

export default LocaleSelect;
